.root {
  align-items: center;
  height: 100%;
  margin-right: 1rem;
  border-color: transparent;
  border-bottom: 3px solid;
}
